import React, { useState, useEffect } from "react";

import { auth, db } from "../../../firebase";
import { doc, setDoc } from "firebase/firestore";

import axios from "axios";

import Popup from '../../mobile/Popup';

import styleClasses from '../css/mobile/MyPage.module.scss';

// 🔹 활동 정보를 가져오는 API 엔드포인트 (API 서버 URL은 상황에 맞게 수정)
const API_ACTIVITY_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/activity/youtube";
const API_ACTIVITY_KOPIS_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/activity/kopis";
const API_ACTIVITY_KCISA_URL = "https://music-api-134893551192.asia-northeast3.run.app/api/activity/kcisa";

function ImportActivityPopup({ open, setOpenPopup, fetchActivities }) {
  const striptags = require("striptags");
  const he        = require("he");

  const [active, setActive]       = useState(open ? styleClasses.active : '');
  const [uid, setUid]             = useState(null);
  const [authToken, setAuthToken] = useState("");     // Firebase Auth JWT 토큰

  const [channelUrl, setChannelUrl]             = useState("");     // 유튜브 채널 URL 입력값
  const [playlistUrl, setPlaylistUrl]           = useState("");     // 플레이리스트 URL 입력값
  const [videoUrl, setVideoUrl]                 = useState("");     // 동영상 URL 입력값
  const [activities, setActivities]             = useState([]);     // 가져온 활동 목록
  const [pushActivities, setPushActivities]     = useState([]);
  const [showActivityList, setShowActivityList] = useState(false);
  const [loading, setLoading]                   = useState(false);
  const [showProgress, setShowProgress]         = useState(false);
  const [progress, setProgress]                 = useState(0);

  const [searchLoading, setSearchLoading]                     = useState(false);
  const [emptySearchKeyword, setEmptySearchKeyword]           = useState('');
  const [checkedYouTubeChannel, setCheckedYouTubeChannel]     = useState(true);   // 유튜브 채널
  const [checkedYouTubePlayList, setCheckedYouTubePlayList]   = useState(false);  // 유튜브 플레이리스트
  const [checkedYouTubeVideo, setCheckedYouTubeVideo]         = useState(false);  // 유튜브 동영상
  const [checkedKOPISPerformance, setCheckedKOPISPerformance] = useState(false);  // 공연예술통합전산망 공연
  const [checkedKCISAPerformance, setCheckedKCISAPerformance] = useState(false);  // 문화체육관광부 공연
  const [checkedKCISAEvent, setCheckedKCISAEvent]             = useState(false);  // 문화체육관광부 행사

  // KOPIS 관련 상태
  const [stdate, setStdate]                           = useState("");   // 공연시작일 (YYYYMMDD)
  const [kopisStartDateError, setKopisStartDateError] = useState('');
  const [eddate, setEddate]                           = useState("");   // 공연종료일 (YYYYMMDD)
  const [kopisEndDateError, setKopisEndDateError]     = useState('');
  const [shprfnm, setShprfnm]                         = useState(""); // 공연명
  const [kopisNameError, setKopisNameError]           = useState('');

  // KCISA 공연 관련 상태 (공연분류값와 공연명 검색값)
  const [kcisaCategory, setKcisaCategory]           = useState(""); // 예: "뮤지컬", "연극", ...
  const [kcisaCategoryError, setKcisaCategoryError] = useState('');
  const [kcisaTitle, setKcisaTitle]                 = useState("");         // 검색값 (공연명)
  const [kcisaTitleError, setKcisaTitleError]       = useState('');

  // KCISA 행사 관련 상태
  const [keyword, setKeyword]           = useState("");

  const [openInnerPopup, setOpenInnerPopup]   = useState(false);
  const [innerPopupTitle, setInnerPopupTitle] = useState('');
  const [innerPopupText, setInnerPopupText]   = useState('');

  // 🔹 팝업 열기/닫기
  useEffect(() => {
    setActive(open ? styleClasses.active : '');
    setShowProgress(false);
    setProgress(0);

    if (open) {
      setCheckedYouTubeChannel(true);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(false);
      setEmptySearchKeyword('');
      setKopisStartDateError('');
      setKopisEndDateError('');
      setKopisNameError('');
      setKcisaCategoryError('');
      setKcisaTitleError('');
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
      setActivities([]);
      setShowActivityList(false);
    }
  }, [open])

  // Firebase 로그인 상태 감지 및 토큰 저장
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUid(user.uid);
        const token = await user.getIdToken();
        setAuthToken(token);
      }
    });
    return () => unsubscribe();
  }, []);

  // 🔹 음원 링크 선택
  const showOption = (event) => {
    setPushActivities([]);

    const option  = event.target.id;
    if (option === 'youTubeChannel') {
      setCheckedYouTubeChannel(true);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(false);
    } else if (option === 'youTubePlayList') {
      setCheckedYouTubeChannel(false);
      setCheckedYouTubePlayList(true);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(false);
    } else if (option === 'youTubeVideo') {
      setCheckedYouTubeChannel(false);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(true);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(false);
    } else if (option === 'kopisPerformance') {
      setCheckedYouTubeChannel(false);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(true);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(false);
    } else if (option === 'kcisaPerformance') {
      setCheckedYouTubeChannel(false);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(true);
      setCheckedKCISAEvent(false);   
    } else if (option === 'kcisaEvent') {
      setCheckedYouTubeChannel(false);
      setCheckedYouTubePlayList(false);
      setCheckedYouTubeVideo(false);
      setCheckedKOPISPerformance(false);
      setCheckedKCISAPerformance(false);
      setCheckedKCISAEvent(true);
    }
    setEmptySearchKeyword('');
    setKopisStartDateError('');
    setKopisEndDateError('');
    setKopisNameError('');
    setKcisaCategoryError('');
    setKcisaTitleError('');
    setChannelUrl('');
    setPlaylistUrl('');
    setVideoUrl('');
    setStdate('');
    setEddate('');
    setShprfnm('');
    setKcisaCategory('');
    setKcisaTitle('');
    setKeyword('');
    setActivities([]);
    setShowActivityList(false);
  }

  // 문자열 정제 함수: 슬래시 등을 치환
  const sanitizeString = (str) => {
    // 슬래시 외에 필요시 다른 특수문자도 추가로 처리 가능
    return str.replace(/\//g, '-').trim();
  };

  // 🔹 검색 필드 입력
  const changeInput = (event) => {
    const id    = event.target.id;
    const value = event.target.value;
    
    if (value !== '') setEmptySearchKeyword('');

    if (id === 'youTubeChannelUrl') {
      setChannelUrl(value);
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
    } else if (id === 'youTubePlayListUrl') {
      setChannelUrl('');
      setPlaylistUrl(value);
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
    } else if (id === 'youTubeVideoUrl') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl(value);
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
    } else if (id === 'kopisStartDate') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate(value);
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
      if (value !== '') setKopisStartDateError('');
    } else if (id === 'kopisEndDate') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setEddate(value);
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
      if (value !== '') setKopisEndDateError('');
    } else if (id === 'kopisName') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setShprfnm(value);
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword('');
      if (value !== '') setKopisNameError('');
    } else if (id === 'kcisaCategory') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory(value);
      setKeyword('');
      if (value !== '') setKcisaCategoryError('');
    } else if (id === 'kcisaTitle') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaTitle(value);
      setKeyword('');
      if (value !== '') setKcisaTitleError('');
    } else if (id === 'kcisaKeyword') {
      setChannelUrl('');
      setPlaylistUrl('');
      setVideoUrl('');
      setStdate('');
      setEddate('');
      setShprfnm('');
      setKcisaCategory('');
      setKcisaTitle('');
      setKeyword(value);
    }
  }

  // 🔹 앨범 선택 (체크박스)
  const checkActivity = (checked, activity) => {
    setPushActivities(prev => 
      checked 
        ? [...prev, activity]
        : prev.filter(item => item.id !== activity.id)
    );

    const safeActivityCardClass = CSS.escape(styleClasses.albumCard);
    const allActivities = document.querySelectorAll(`.${safeActivityCardClass} input[name="eachActivity"]`);
    const checkedActivities = document.querySelectorAll(`.${safeActivityCardClass} input[name="eachActivity"]:checked`);
    const allCheckBox = document.getElementById("checkAllActivities");
    if (allActivities && allCheckBox) {
      allCheckBox.checked = allActivities.length === checkedActivities.length;
    }    
  }

  // 🔹 모든 앨범 선택/해제
  const checkAllActivities  = (checked) => {
    const safeAlbumCardClass = CSS.escape(styleClasses.albumCard);
    const targetActivities  = document.querySelectorAll(`.${ safeAlbumCardClass } input[name=eachActivity]`);

    if (targetActivities.length) {
      if (checked) {
        targetActivities.forEach(eachActivity => eachActivity.checked = true);
        setPushActivities(activities);
      } else {
        targetActivities.forEach(eachActivity => eachActivity.checked = false);
        setPushActivities([]);
      }
    }
  }

  // 🔹 유트브 채널, 플레이리스트, 동영상 URL 중 하나를 사용하여 활동 가져오기
  const fetchActivitiesFromYouTube = async () => {
  // 초기화
  setActivities([]);
  setPushActivities([]);
  setShowActivityList(false);

    // 우선순위: 플레이리스트 URL > 동영상 URL > 채널 URL
    let params = {};

    if (playlistUrl) {
      params.playlistUrl = playlistUrl;
      console.log("🎤 플레이리스트 URL 입력:", playlistUrl);
    } else if (videoUrl) {
      params.videoUrl = videoUrl;
      console.log("🎤 동영상 URL 입력:", videoUrl);
    } else if (channelUrl) {
      params.channelUrl = channelUrl;
      console.log("🎤 채널 URL 입력:", channelUrl);
    } else {
      setEmptySearchKeyword('error');
      return false;
    }

    try {
      setSearchLoading(true);
      const response = await axios.get(API_ACTIVITY_URL, {
        params,
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("🎶 API 응답 데이터:", response.data);
      setActivities(response.data.activities);
      setShowActivityList(true);
    } catch (error) {
      console.error("❌ 활동 API 호출 실패:", error.response?.data || error.message);
      setShowActivityList(false);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('활동 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setSearchLoading(false);
    }
  };

  // 🔹 KOPIS 활동 데이터를 가져오는 함수
  const fetchKopisActivities = async () => {
    // 초기화
    setActivities([]);
    setPushActivities([]);
    setShowActivityList(false);

    if (!stdate) {
      setKopisStartDateError('error');
      return false;
    } else if (!eddate) {
      setKopisEndDateError('error');
      return false;
    } else if (!shprfnm) {
      setKopisNameError('error');
      return false;
    } else {
      setSearchLoading(true);
    }
    
    try {
      const response = await axios.get(API_ACTIVITY_KOPIS_URL, {
        params: { stdate, eddate, shprfnm },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("🎶 KOPIS API 응답 데이터:", response.data);
      const mapped = response.data.activities.map((perf) => ({
        id: perf.id,
        title: perf.title,
        date: perf.date, // 이미 원하는 형식(예: "YYYY.MM.DD")일 수 있으므로 필요시 변환 적용
        channel: perf.channel,
        photo: perf.photo,
        description: perf.description || ""
      }));
      setShowActivityList(true);
      setActivities(mapped);
    } catch (error) {
      console.error("❌ KOPIS 활동 API 호출 실패:", error.response?.data || error.message);
      setShowActivityList(false);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('KOPIS 활동 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setSearchLoading(false);
    }
  };

  // 🔹 KCISA 활동 데이터를 가져오는 함수
  const fetchKcisaActivities = async () => {
    // 초기화
    setActivities([]);
    setPushActivities([]);
    setShowActivityList(false);

    if (!kcisaCategory) {
      setKcisaCategoryError('error');
      return false;
    } else if (!kcisaTitle) {
      setKcisaTitleError('error');
      return false;
    } else {
      setSearchLoading(true);
    }

    try {
      const response = await axios.get(API_ACTIVITY_KCISA_URL, {
        params: { dtype: kcisaCategory, title: kcisaTitle },
        headers: { Authorization: `Bearer ${authToken}` },
      });
      console.log("🎶 KCISA API 응답 데이터:", response.data);

      let items = response.data.activities;
      if (!items) {
        items = [];
      }
      if (!Array.isArray(items)) {
        items = [items];
      }
      const mapped = items.map((item, index) => ({
        id: item.id ? sanitizeString(item.id) : sanitizeString(`${item.title}_${index}`),
        title: item.title ? he.decode(striptags(item.title)) : "",
        date: item.date 
        ? `${item.date.slice(0, 4)}-${item.date.slice(4, 6)}-${item.date.slice(6, 8)}` 
        : "",
        channel: item.channel || "",
        description: item.description ? he.decode(striptags(item.description)) : "",
        link: item.link || "",
        photo: item.photo || ""
      }));
      
      setShowActivityList(true);
      setActivities(mapped);
    } catch (error) {
      console.error("❌ KCISA 활동 API 호출 실패:", error.response?.data || error.message);
      setShowActivityList(false);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('KCISA 활동 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setSearchLoading(false);
    }
  };

  // 🔹 KCISA 이벤트 데이터를 가져오는 함수 (keyword 기반)
  const fetchKcisaEvents = async () => {
    // 초기화
    setActivities([]);
    setPushActivities([]);
    setShowActivityList(false);

    if (keyword === '') {
      setEmptySearchKeyword('error');
      return false;
    } else {
      setSearchLoading(true);
    }
    
    try {
      const response = await axios.get(
        "https://music-api-134893551192.asia-northeast3.run.app/api/activity/kcisaEvents",
        {
          params: { keyword },
          headers: { Authorization: `Bearer ${authToken}` },
        }
      );
      console.log("🎶 KCISA events API 응답 데이터:", response.data);
      let items = response.data.activities;
      if (!items) {
        items = [];
      }
      if (!Array.isArray(items)) {
        items = [items];
      }

      const cleanHTML = (html) => {
        return striptags(he.decode(html));
      };

      // 각 이벤트 정보를 원하는 필드로 매핑
      const mapped = items.map((item, index) => {
        let photo = "";
        let descriptionText = item.description ? he.decode(item.description) : "";
      
        // 이미지 태그의 src 속성을 추출하는 정규표현식 (첫 번째 img 태그만 추출)
        const imgRegex = /<img[^>]*src="([^"]+)"[^>]*>/i;
        const imgMatch = descriptionText.match(imgRegex);
        if (imgMatch && imgMatch[1]) {
          photo = imgMatch[1];
        }
      
        // 이미지 태그를 제거한 텍스트
        const cleanedDescription = cleanHTML(descriptionText);
      
        return {
          id: item.id ? sanitizeString(item.id) : sanitizeString(`${item.title}_${index}`),
          title: item.title ? cleanHTML(item.title) : "",
          description: cleanedDescription,
          link: item.link || "",
          channel: item.channel || "",
          date: item.date ? item.date.split(" ~ ")[0] : "",
          photo: photo
        };
      });
      setActivities(mapped);
      setShowActivityList(true); 
    } catch (error) {
      console.error("❌ KCISA events API 호출 실패:", error.response?.data || error.message);
      setShowActivityList(false);
      
      setOpenInnerPopup(true);
      setInnerPopupTitle('KCISA 이벤트 검색 중 오류가 발생했습니다.');
      setInnerPopupText('');
    } finally {
      setSearchLoading(false);
    }
  };

  // 🔹 Firestore에 활동 정보를 저장 (users_data > uid > activity)
  const handleAddActivity = async () => {
    if (!uid) {
      setOpenInnerPopup(true);
      setInnerPopupTitle('로그인이 필요합니다.');
      setInnerPopupText('');
      return;
    } else if (pushActivities.length === 0) {
      setOpenInnerPopup(true);
      setInnerPopupTitle('활동을 선택해주세요.');
      setInnerPopupText('');
      return;
    } else {
      setLoading(true);
    }

    try {
      const activityTitles = [];

      let allItemsLength  = pushActivities.length;
      let currentProgress = 1;
      if (allItemsLength > 2) {
        setShowProgress(true);
        setTimeout(() => {
          setProgress(((currentProgress / allItemsLength) * 100).toFixed(2));
        }, 100);
      }

      for (const activity of pushActivities) {
        // Firestore 문서 ID는 activity.id (API에서 제공되는 고유값) 사용
        const activityRef   = doc(db, "users_data", uid, "activity", activity.id);
        const activityData  = {};
        
        activityData.title        = activity.title;
        activityData.date         = activity.date.split("T")[0] || activity.date;
        activityData.description  = activity.description || '';
        if (checkedYouTubeChannel || checkedYouTubePlayList || checkedYouTubeVideo) {
          activityData.channel      = `[YouTube] ${ activity.channel }`;
          activityData.channelType  = 'YouTube';
        } else if (checkedKOPISPerformance || checkedKCISAPerformance || checkedKCISAEvent) {
          activityData.channel      = `[기타] ${ activity.channel }`;
          activityData.channelType  = '기타';
        }
        activityData.videoId      = activity.videoId || '';
        activityData.photo        = activity.photo || '';
        activityData.link         = activity.link || '';
        activityData.createdAt    = new Date().toISOString();
        
        await setDoc(activityRef, activityData);
        activityTitles.push(`<p><strong>"${ activity.title }"</strong> 활동이 추가되었습니다.</p>`);

        if (allItemsLength > 2) {
          currentProgress++;
          const percent = currentProgress / allItemsLength * 100;
          if (percent === 100) {
            setProgress(99);  
          } else {
            setProgress(((currentProgress / allItemsLength) * 100).toFixed(2));
          }
        }
      }

      setShowProgress(false);
      setProgress(0);

      setLoading(false);
      setOpenInnerPopup(true);
      setInnerPopupTitle('활동에 추가되었습니다.');
      setInnerPopupText(activityTitles.join(''));

      const safeActivityCardClass = CSS.escape(styleClasses.albumCard);
      const checkedActivities     = document.querySelectorAll(`.${ safeActivityCardClass } input[name=eachActivity]:checked`);
      const allCheckBox           = document.getElementById('checkAllActivities');
      if (checkedActivities) {
        checkedActivities.forEach(element => element.checked = false);
      }
      if (allCheckBox) {
        allCheckBox.checked = false;
      }
      setPushActivities([]);

      // fetchActivities()가 정상적으로 전달되는지 확인
      if (typeof fetchActivities === 'function') {
        fetchActivities();
      }
    } catch (error) {
      console.error("❌ 활동 저장 실패:", error);

      setShowProgress(false);
      setProgress(0);

      setLoading(false);
      setOpenInnerPopup(true);
      setInnerPopupTitle('활동 추가 중 오류가 발생했습니다.');
      setInnerPopupText('');
    }
  };

  return (
    <>
      <div className={`${ styleClasses.backDropMobile } ${ active }`} onClick={ () => { setActive(''); setOpenPopup(false); } }/>
      <div className={`${ styleClasses.importAlbumPopupMobile } ${ active }`}>
        <div className={ styleClasses.inner }>
          <div className={ styleClasses.header }>
            <div className={ styleClasses.title }>
              <h1>활동 가져오기</h1>
            </div>
            <div className={ styleClasses.closeButton }>
              <button onClick={ () => { setActive(''); setOpenPopup(false); } }>
                <div className="commonIcon mobile">
                  <i className="closeWhite w32"></i>
                </div>
              </button>
            </div>
            <div className={ styleClasses.selectOption }>
              <div className={`commonForm ${ styleClasses.optionWrapper }`}>
                <div className="formRow">
                  <div className={`fieldBox checkBox ${ styleClasses.optionBoxes }`}>
                    <div className="eachBox">
                      <input type="radio" name="site" id="youTubeChannel" checked={ checkedYouTubeChannel } onChange={ showOption } />
                      <label htmlFor="youTubeChannel">유튜브 채널</label>
                    </div>
                    <div className="eachBox">
                      <input type="radio" name="site" id="youTubePlayList" checked={ checkedYouTubePlayList } onChange={ showOption } />
                      <label htmlFor="youTubePlayList">유튜브 플레이리스트</label>
                    </div>
                    <div className="eachBox">
                      <input type="radio" name="site" id="youTubeVideo" checked={ checkedYouTubeVideo } onChange={ showOption } />
                      <label htmlFor="youTubeVideo">유튜브 동영상</label>
                    </div>
                    <div className="eachBox">
                      <input type="radio" name="site" id="kopisPerformance" checked={ checkedKOPISPerformance } onChange={ showOption } />
                      <label htmlFor="kopisPerformance">공연예술통합전산망</label>
                    </div>
                    <div className="eachBox">
                      <input type="radio" name="site" id="kcisaPerformance" checked={ checkedKCISAPerformance } onChange={ showOption } />
                      <label htmlFor="kcisaPerformance">문화공공데이터 공연</label>
                    </div>
                    <div className="eachBox">
                      <input type="radio" name="site" id="kcisaEvent" checked={ checkedKCISAEvent } onChange={ showOption } />
                      <label htmlFor="kcisaEvent">문화공공데이터 행사</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`${ styleClasses.content }`}>
            <div className={`${styleClasses.searchBox} ${ styleClasses.active }`}>
              <div className={ styleClasses.description }>
                {
                  checkedYouTubeChannel
                  ?
                  (
                    <>
                      <h2>유튜브 활동 가져오기 (채널 URL)</h2>
                      <p>유튜브 채널 URL을 입력하면, 해당 채널의 업로드된 모든 동영상 및 쇼츠 활동을 가져옵니다.</p>
                      <p>예) https://www.youtube.com/@user_ID</p>
                    </>
                  )
                  :
                  checkedYouTubePlayList
                  ?
                  (
                    <>
                      <h2>유튜브 활동 가져오기 (플레이리스트 URL)</h2>
                      <p>플레이리스트 URL을 입력하면, 해당 활동 정보를 가져옵니다.</p>
                      <p>예) 플레이리스트: https://www.youtube.com/playlist?list=[플레이리스트ID]</p>
                    </>
                  )
                  :
                  checkedYouTubeVideo
                  ?
                  (
                    <>
                      <h2>유튜브 활동 가져오기 (동영상 URL)</h2>
                      <p>동영상 URL을 입력하면, 해당 활동 정보를 가져옵니다.</p>
                      <p>예) 동영상: https://www.youtube.com/watch?v=[비디오ID]</p>
                    </>
                  )
                  :
                  checkedKOPISPerformance
                  ?
                  (
                    <>
                      <h2>공연예술통합전산망(KOPIS) 공연 활동 검색</h2>
                      <p>공연시작일, 공연종료일, 공연명을 입력하세요.</p>
                      <p>예) 공연시작일: 20230108, 공연종료일: 20230112, 공연명: 사랑</p>
                    </>
                  )
                  :
                  checkedKCISAPerformance
                  ?
                  (
                    <>
                      <h2>문화공공데이터(KCISA) 공연 활동 검색</h2>
                      <p>공연 분류(연극, 뮤지컬, 오페라, 음악, 콘서트, 국악, 무용, 전시, 기타)와 공연명을 입력하세요.</p>
                      <p>예) 공연 분류: 뮤지컬, 공연명: 사랑</p>
                    </>
                  )
                  :
                  checkedKCISAEvent
                  ?
                  (
                    <>
                      <h2>문화공공데이터(KCISA) 행사 활동 검색</h2>
                      <p>검색할 키워드(keyword)를 입력하세요.</p>
                    </>
                  )
                  :
                  ''
                }
                
              </div>
              <div className={`commonForm ${ styleClasses.searchField }`}>
                <div className="formRow">
                  <div className={`fieldBox ${ emptySearchKeyword } ${ styleClasses.inputField }`}>
                    {
                      checkedYouTubeChannel
                      ?
                      (
                        <>
                          {/* 유튜브 활동 가져오기: 채널 URL */}
                          <input type="text" id="youTubeChannelUrl" placeholder="유튜브 채널 URL 입력" value={ channelUrl } onChange= { changeInput } />
                          <div className="fieldError">
                            <p>유튜브 채널 URL을 입력하세요.</p>
                          </div>
                        </>
                      )
                      :
                      checkedYouTubePlayList
                      ?
                      (
                        <>
                          {/* 유튜브 활동 가져오기: 플레이리스트 URL */}
                          <input type="text" id="youTubePlayListUrl" placeholder="플레이리스트 URL 입력" value={ playlistUrl } onChange={ changeInput } />
                          <div className="fieldError">
                            <p>유튜브 플레이리스트 URL을 입력하세요.</p>
                          </div>
                        </>
                      )
                      :
                      checkedYouTubeVideo
                      ?
                      (
                        <>
                          {/* 유튜브 활동 가져오기: 동영상 URL */}
                          <input type="text" id="youTubeVideoUrl" placeholder="동영상 URL 입력" value={videoUrl} onChange={ changeInput } />
                          <div className="fieldError">
                            <p>유튜브 동영상 URL을 입력하세요.</p>
                          </div>
                        </>
                      )
                      :
                      checkedKOPISPerformance
                      ?
                      (
                        <>
                          <div className={`fieldBox ${ kopisStartDateError } ${ styleClasses.multipleField }`}>
                            <input type="text" id="kopisStartDate" placeholder="공연 시작일 (YYYYMMDD)" value={stdate} onChange={ changeInput } />
                            <div className="fieldError">
                              <p>공연 시작일을 입력하세요.</p>
                            </div>
                          </div>
                          <div className={`fieldBox ${ kopisEndDateError } ${ styleClasses.multipleField }`}>
                            <input type="text" id="kopisEndDate" placeholder="공연 종료일 (YYYYMMDD)" value={eddate} onChange={ changeInput } />
                            <div className="fieldError">
                              <p>공연 종료일을 입력하세요.</p>
                            </div>
                          </div>
                          <div className={`fieldBox ${ kopisNameError } ${ styleClasses.multipleField }`}>
                            <input type="text" id="kopisName" placeholder="공연명 입력" value={shprfnm} onChange={ changeInput } />
                            <div className="fieldError">
                              <p>공연명을 입력하세요.</p>
                            </div>
                          </div>
                        </>
                      )
                      :
                      checkedKCISAPerformance
                      ?
                      (
                        <>
                          <div className={`fieldBox ${ kcisaCategoryError } ${ styleClasses.multipleField }`}>
                            <input type="text" id="kcisaCategory" placeholder="공연 분류 입력 (예: 뮤지컬)" value={ kcisaCategory } onChange={ changeInput } />
                            <div className="fieldError">
                              <p>공연 분류를 입력하세요.</p>
                            </div>
                          </div>
                          <div className={`fieldBox ${ kcisaTitleError } ${ styleClasses.multipleField }`}>
                            <input type="text" id="kcisaTitle" placeholder="공연명 입력" value={ kcisaTitle } onChange={ changeInput } />
                            <div className="fieldError">
                              <p>공연명을 입력하세요.</p>
                            </div>
                          </div>
                        </>
                      )
                      :
                      checkedKCISAEvent
                      ?
                      (
                        <>
                          <input type="text" id="kcisaKeyword" placeholder="키워드 입력" value={ keyword } onChange={ changeInput } />
                          <div className="fieldError">
                            <p>키워드를 입력하세요.</p>
                          </div>
                        </>
                      )
                      :
                      ''
                    }
                    
                  </div>
                  <div className={`commonButton ${ styleClasses.searchButton }`}>
                    <button
                      className="black"
                      onClick={ 
                        () => 
                        checkedKOPISPerformance
                        ?
                        fetchKopisActivities()
                        :
                        checkedKCISAPerformance
                        ?
                        fetchKcisaActivities()
                        :
                        checkedKCISAEvent
                        ?
                        fetchKcisaEvents()
                        :
                        fetchActivitiesFromYouTube()
                       }
                      disabled={ searchLoading }
                    >
                      <div className="commonIcon mobile">
                        <i className="searchWhite w24"></i>
                      </div>
                      <div className={`buttonLoading ${ searchLoading && 'active' }`}>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* 활동 목록 나열 */}
            <div className={`${ styleClasses.albumList } ${ showActivityList ? styleClasses.active : '' }`}>
            {
              activities.length > 0
              ?
              (
                activities.map((activity) => (
                  <div key={activity.id} className={styleClasses.albumCard}>
                    <div className={ styleClasses.checkBox }>
                      <div className="commonForm">
                        <div className="formRow">
                          <div className="fieldBox">
                            <input type="checkbox" name="eachActivity" onChange={ (e) => checkActivity(e.target.checked, activity) } />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* 활동 정보 (썸네일 + 제목 + 발행일) */}
                    <div className={ styleClasses.albumHeader }>
                      {(checkedKOPISPerformance || checkedKCISAPerformance || checkedKCISAEvent) ? (
                        activity.photo ? (
                          <img src={activity.photo} alt="활동 썸네일" onError={(e) => { e.target.onerror = null; e.target.src = '/assets/images/image_error.svg'; }}/>
                        ) : (
                          <div className={styleClasses.defaultImageContainer}>
                            <img src="/assets/images/no_image.svg" alt="이미지 없음"/>
                          </div>
                        )
                      ) : (
                        activity.videoId ? (
                          <img src={`https://img.youtube.com/vi/${activity.videoId}/0.jpg`} alt="활동 썸네일" />
                        ) : (
                          <div className={styleClasses.defaultImageContainer}>
                            <img src="/assets/images/no_image.svg" alt="이미지 없음"/>
                          </div>
                        )
                      )}
                      <div className={ styleClasses.infoBox }>
                        <p>{activity.title}</p>
                        {
                          activity.channel && ( <p><strong>채널 :</strong> {activity.channel}</p> )
                        }
                        <p><strong>발행일 :</strong> {activity.date?.split('T')[0]}</p>
                        {/* 활동 설명 (있을 경우) */}
                        { activity.description && ( <p>{activity.description}</p> ) }
                      </div>
                    </div>
                  </div>
                ))
              )
              :
              (
                <p className={ styleClasses.noResults }>검색 결과가 없습니다.</p>
              )
            }
            </div>
          </div>
          {
            activities.length > 0
            &&
            (
              <div className={ styleClasses.footer }>
                {
                  showProgress
                  ?
                  (
                    <div className={ styleClasses.progressBarDiv }>
                      <div className={ styleClasses.progressBar }>
                        <div className={ styleClasses.progress }>
                          <div className={ styleClasses.inProgress } style={{ width: `${ progress }%` }}></div>
                          <div className={ styleClasses.percent}>
                            <span>{`${ progress }%`}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                  :
                  null
                }
                <div className="commonForm">
                  <div className="formRow">
                    <div className="fieldBox checkBox">
                      <div className="eachBox">
                        <input type="checkbox" id="checkAllActivities" onChange={ (e) => checkAllActivities(e.target.checked) } />
                        <label htmlFor="checkAllActivities">모든 활동 선택</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="commonButton">
                  <button className="black" onClick={ handleAddActivity } disabled={ loading }>
                    활동 추가
                    <div className={`buttonLoading ${ loading && 'active' }`}>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </button>
                </div>
                <p className={ styleClasses.fieldDescription }>· 활동이 많을수록 추가에 시간이 걸립니다.</p>
              </div>
            )
          }
        </div>
      </div>
      <Popup open={ openInnerPopup } setOpenPopup={ setOpenInnerPopup } title={ innerPopupTitle } text={ innerPopupText } buttonText='' buttonFunction='' buttonLoading='' />
    </>
  );
}

export default ImportActivityPopup;